import { useTranslations } from '@vocab/react';
import {
  Box,
  Heading,
  Card,
  Columns,
  Column,
  Text,
  Stack,
  Actions,
  IconNewWindow,
  ButtonLink,
} from 'braid-design-system';
import React from 'react';

import { FIND_MORE_CANDIDATES_PRESSED } from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';

import translations from './.vocab';

export const RecommendedCandidatesPanel = () => {
  const { t } = useTranslations(translations);
  const { getRecommendedCandidatesUrl } = useLocalisedRoutes();

  const onFindCandidates = () => {
    const eventData = {
      eventName: FIND_MORE_CANDIDATES_PRESSED,
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  };

  return (
    <Card>
      <Box padding="small">
        <Columns
          space={{ mobile: 'small', desktop: 'xxlarge' }}
          collapseBelow="tablet"
          alignY="center"
        >
          <Column>
            <Stack space="large">
              <Heading level="3">
                {t('recommended-candidates-panel-heading')}
              </Heading>
              <Text tone="secondary">
                {t('recommended-candidates-panel-description')}
              </Text>
            </Stack>
          </Column>
          <Column width="content">
            <Box paddingTop={['large', 'none']}>
              <Actions>
                <ButtonLink
                  variant="ghost"
                  id="find-candidates"
                  target="_blank"
                  icon={<IconNewWindow />}
                  href={getRecommendedCandidatesUrl()}
                  onClick={onFindCandidates}
                >
                  {t('find-candidates-button')}
                </ButtonLink>
              </Actions>
            </Box>
          </Column>
        </Columns>
      </Box>
    </Card>
  );
};
